import React, { useContext, useEffect, useState } from "react";
import { ManagerDashboard } from "./ManagerDashboard";
import { Box, Heading } from "grommet";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import API_URL from "../../config/config";
import axios from "axios";
import { LinkPrevious } from "grommet-icons";
import BreadcrumbNavigation from "./BreadcrumbNavigation";
// import { required } from "joi";

function HeaderComponent({ current, previous, current_link_name, previous_link_name, flag = false, color_modify = 0, required}) {
  const { jwtToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const { manager_id } = useParams(); // Access manager_id from the URL params
  const [username, setUsername] = useState("");
  const [userid, setUserId] = useState("");

  useEffect(() => {
    const fetchUserInitials = async () => {
      if (jwtToken) {
        try {
          const decodedToken = jwtDecode(jwtToken);
          const userId = decodedToken.user_id;
          setUserId(userId);

          const storedUsername = localStorage.getItem("managername");
          if (storedUsername) {
            setUsername(storedUsername);
          } else if (userId) {
            const response = await axios.get(
              `${API_URL}/user/getManagerNameById/${userId}`,
            );
            const fetchedName = response.data.name;
            localStorage.setItem("managername", fetchedName);
            setUsername(fetchedName);
          }
        } catch (err) {
          console.error("Error fetching user initials:", err);
        }
      }
    };
    fetchUserInitials();
  }, [jwtToken]);

  return (
    <Box as="header" flex={false}>
      {/* Only show back arrow if flag is false */}
      {!flag && (
        <Box
          margin={{ horizontal: "medium", top: "small" }}
          direction="row"
          align="center"
          justify="between"
        >
          {/* Left side: Back Arrow + Breadcrumb Navigation */}
          <Box direction="row" align="center" gap="small">
            <LinkPrevious
              size="large"
              onClick={() => navigate(`/${manager_id}/manager/dashboard`)}
              color="brand"
              style={{ cursor: "pointer" }}
            />
            <BreadcrumbNavigation 
            current={current} 
            previous={previous} 
            current_link_name={current_link_name} 
            previous_link_name={previous_link_name} 
            />
          </Box>

          {/* Right side: Manager Dashboard or other nav items */}
          <ManagerDashboard color_modify={color_modify} required={required}/>
        </Box>
      )}

      {/* If you use `flag === true`, handle the layout differently as you wish */}
      {flag && (
        <Box
          margin={{ horizontal: "medium", top: "small" }}
          direction="row"
          align="center"
          justify="between"
        >
          <BreadcrumbNavigation 
          current={current} 
            previous={previous} 
            current_link_name={current_link_name} 
            previous_link_name={previous_link_name} 
          />
          <ManagerDashboard />
        </Box>
      )}

      {/* Horizontal divider */}
      <Box
        margin={{ top: "small" }}
        border={{ color: "brand", size: "xsmall", side: "bottom" }}
        width="full"
      />
    </Box>
  );
}

export default HeaderComponent;
